import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/components_tongtu/HomePage'
import HomePage2 from '@/components_wav2lip/HomePage2'
import HomePage3 from '@/components_xitan/HomePage3'
import HomePage4 from '@/components_cxw/HomePage4'
import HomePage5 from '@/components_hsraz/HomePage5'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/hsraz',
      name: 'hsraz',
      component: HomePage5
    },
    {
      path: '/',
      name: 'caixiaowen',
      component: HomePage4
    },
    {
      path: '/xitan',
      name: 'xitan',
      component: HomePage3
    },
    {
      path: '/wav2lip',
      name: 'wav2lip',
      component: HomePage2
    },
    {
      path: '/tongtu',
      name: 'tongtu',
      component: HomePage
    }
  ],
  //mode: "history"//干掉地址栏里边的#号键
})
